import { FC, ReactNode } from 'react';
import { ProTooltip } from '../../antd';
import { FormInstance } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { filterEmptyValue } from "../../utils/utils";
import { renderEnumName, renderEnumNames } from '../../utils/renderUtils';
import { TABLE_COLUMN_EMPTY } from '../../constants/constant';

interface DisabledProps {
  name?: NamePath;
  form?: FormInstance;
  render?: ReactNode | Function;
  options?: any[];
}

const Disabled: FC<DisabledProps> = props => {
  const { render, name, form, options } = props;
  const renderChildren = (): ReactNode => {
    if (!name || !form) return TABLE_COLUMN_EMPTY;
    const nameText = form.getFieldValue(name);
    if (options) {
      if (Array.isArray(nameText)) return renderEnumNames(nameText, options);
      return renderEnumName(nameText, options);
    }
    return filterEmptyValue(nameText);
  };
  const renderChild = () => {
    const nameText = form?.getFieldValue(name || '');
    if (typeof render === 'function') return render(nameText);
    return render;
  };
  const disableText: ReactNode = render ? renderChild() : renderChildren();
  return (
    <ProTooltip title={disableText} placement="topLeft">
      <div className="yb-line-ellipsis">{disableText}</div>
    </ProTooltip>
  );
};

export default Disabled;
